import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, concatLatestFrom } from '@ngrx/effects';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as statesActions from 'src/app/shared/actions/states.actions';
import { StatesService } from 'src/app/shared/services/states.service';
import { getStates } from 'src/app/shared/selectors/states.selectors';

@Injectable()
export class StatesEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _service: StatesService,
        private readonly _store: Store
    ) {}

    getStates$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(statesActions.loadStates),
            concatLatestFrom(() => this._store.select(getStates)),
            switchMap(() => {
                return this._service.getStates().pipe(
                    map((states) => statesActions.loadStatesSuccess({ states: states })),
                    catchError((result) => of(statesActions.loadStatesFailure({ error: result })))
                );
            })
        );
    });
}
